import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, ButtonProps } from "@mui/material";
import { SxProps, Theme, useTheme } from "@mui/system";

interface LinkButtonProps extends ButtonProps {
  to: string;
  color: any;
}

export const LinkButton: React.FC<LinkButtonProps> = ({
  to,
  children,
  color,
  variant,
  ...props
}) => {
  const theme = useTheme();

  const getTextColor = (): string => {
    if (variant === "contained") {
      const backgroundColor = theme.palette[color].main as string;
      const contrastText = theme.palette.getContrastText(
        backgroundColor
      ) as string;
      return contrastText;
    }
    return theme.palette[color].main as string;
  };

  const textColor = getTextColor();

  return (
    <Button
      component={RouterLink}
      to={to}
      color={color}
      variant={variant}
      {...props}
      sx={{
        color: textColor,
        "&:hover": {
          color: textColor // ensuring the text color remains the same on hover
        },
        ...(props.sx as SxProps<Theme>)
      }}
    >
      {children}
    </Button>
  );
};
